import { CSSProperties } from 'styled-components'
import { Wrapper } from './WaveDivider.styles'

type WaveDividerProps = {
  curveSize: 'small' | 'medium' | 'large'
  style?: CSSProperties
  fill?: string
  topDivider?: boolean
  inverse?: boolean
}

const WaveDivider: React.FC<WaveDividerProps> = ({
  curveSize = 'small',
  style,
  fill = '#FFFFFF',
  topDivider = false,
  inverse = false,
}) => {
  const renderDivider = () => {
    if (curveSize == 'small') {
      return (
        <svg
          data-testid="small-curve"
          preserveAspectRatio="none"
          viewBox="0 0 1440 118"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2_28)">
            <path
              fill={fill}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M472.566 28.6729C201.401 -8.66509 0 19.5461 0 19.5461V118H1440V71.4048V0L1439.98 -3.05176e-05L1440 71.4048C1106.12 143.515 871.207 99.8597 652.861 59.2831C592.071 47.9861 532.566 36.9278 472.566 28.6729Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_2_28">
              <rect width="1440" height="118" />
            </clipPath>
          </defs>
        </svg>
      )
    } else if (curveSize == 'medium') {
      return (
        <svg
          data-testid="medium-curve"
          preserveAspectRatio="none"
          viewBox="0 0 1440 302"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_25)">
            <path
              fill={fill}
              d="M1179.63 1643.24C712.294 1844.61 390.675 1911.84 221.345 1841.89C100.96 1792.16 58.6067 1668.7 17.7068 1549.31C-24.0773 1427.58 -67.1314 1301.92 -205.459 1252.92C-211.903 1250.63 -218.572 1248.51 -225.464 1246.56C-307.072 1223.48 -390.291 1259.05 -486.639 1300.31C-577.629 1339.18 -680.7 1383.25 -752.552 1357.86L-752.602 1357.84C-786.971 1345.72 -818.393 1314.8 -846.035 1266.36C-963.005 1055.52 -1095.55 816.609 -1017.79 572.034C-916.618 253.82 -620.344 16.687 -202.508 -79.2255C-189.899 -82.9221 -176.875 -82.6342 -161.502 -78.2769C-157.797 -77.0634 -118.837 -63.8639 15.3509 50.1608C128.88 146.661 225.623 193.712 309.081 194.232C422.808 199.32 589.1 160.539 817.162 75.9016C1050.21 -6.4433 1176.44 -1.90309 1241.24 16.4014C1270.44 24.6947 1303.4 39.4861 1337.85 59.662C1580.56 210.31 1668.84 501.7 1600.11 926.051C1594.26 968.088 1590.5 1010.23 1587.01 1051C1567.57 1273.65 1549.2 1483.91 1179.68 1643.25L1179.63 1643.24Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_25">
              <rect width="1440" height="302" />
            </clipPath>
          </defs>
        </svg>
      )
    } else {
      return (
        <svg
          data-testid="large-curve"
          preserveAspectRatio="none"
          viewBox="0 0 1440 414.1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill={fill}
            d="M1440,4.5v409.6H0V24.2c3.7,0.4,7.4,1.1,11.3,2.2c3.7,1.2,42.6,14.7,169.4,151.9
C288,294.4,383.1,346.8,469.2,338.8c116.9-5,292.7-73.5,537-209.2C1242.8,3.2,1371.9-9.5,1440,4.5z"
          />
        </svg>
      )
    }
  }

  return (
    <Wrapper topDivider={topDivider} inverse={inverse} style={style} data-testid="wave-divider-cont">
      {renderDivider()}
    </Wrapper>
  )
}

export default WaveDivider
